import { error } from "toastr"
import {
  PROFILE_COMPLETION_START,
  PROFILE_COMPLETION_SUCCESS,
  PROFILECOMPLETION_ERROR,
  PROFILECOMPLETION_RESET,
} from "./actionTypes"

export const ProfileCompletion = () => {
  return { type: PROFILE_COMPLETION_START }
}

export const ProfileCompletionSuccess = (payload) => {
  return { type: PROFILE_COMPLETION_SUCCESS, payload }
}

export const ProfileCompletionError = error => {
  return { type: PROFILECOMPLETION_ERROR, payload: error }
}

export const ProfileCompletionReset = () => {
  return { type: PROFILECOMPLETION_RESET }
}
